/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_IntroInputs */

const en_privacy_section_4_intro = /** @type {(inputs: Privacy_Section_4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you first visit our website, you will see a cookie consent banner powered by c15t. Consent is organized into categories (necessary, measurement, marketing) and we only load the third-party scripts you allow:`)
};

const lv_privacy_section_4_intro = /** @type {(inputs: Privacy_Section_4_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad Jūs pirmo reizi apmeklējat mūsu mājaslapu, Jūs redzēsiet sīkdatņu piekrišanas baneri, ko nodrošina c15t. Piekrišana ir organizēta kategorijās (būtiskās, mērījumi, mārketings), un mēs ielādējam tikai tos trešo pušu skriptus, kuriem Jūs piekrītat:`)
};

/**
* | output |
* | --- |
* | "When you first visit our website, you will see a cookie consent banner powered by c15t. Consent is organized into categories (necessary, measurement, marketi..." |
*
* @param {Privacy_Section_4_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_intro = /** @type {((inputs?: Privacy_Section_4_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_intro(inputs)
	return en_privacy_section_4_intro(inputs)
});